
import React, { useContext, useEffect, useState } from 'react';
import { Typography } from '@mui/material';
import { Box, useTheme } from '@mui/system';
import { Container, CourseCard, SearchBar } from '../../components';
import { Main } from '../../components/Main';
import { UserContext } from '../../components/provider';
import { useNavigate, useSearchParams } from 'react-router-dom';
import CircularProgress from '@mui/material/CircularProgress';
import notification from '../../utils/notifications';
import {  stringToPascalCase } from '../../utils/utils';
import { COURSES_URL,  } from '../../config/urls';

const {REACT_APP_BASE_BACKEND_URL} = process.env;
const SEARCH_API_URL = `${REACT_APP_BASE_BACKEND_URL}/api/query-course`;

const CategoriesView = () =>{
  const theme= useTheme();
  const {user} = useContext(UserContext);
  const [queryParams] = useSearchParams();
  const [isLoading, setIsLoading] = useState(false);
  const [courseRelated, setCourseRelated] = useState([]);

  const [topic, setTopic] = useState('');
  const navigate = useNavigate();
  const token = window.localStorage.getItem('jwt');
  useEffect(() => {
    document.title = 'Course Pool | Category';
  }, []);
  useEffect(() => {
    let tag = queryParams.get('t');
    if(tag){
      fetch(`${SEARCH_API_URL}/?t=${tag}`,{
        method: 'GET',
        credentials: 'include',
        headers: { 
          'Content-Type': 'application/json',
          'Authorization': `${token && `jwt ${token}`}`
      }}).then(res => {
        return res.json()
      })
      .then(data => {
        if(data.length) {
          let courses = [];
          for(let i=0; i< data.length; i++){
            courses.push(data[i]);
          }
          setTopic(tag);
          setIsLoading(false);
          setCourseRelated(courses)

        }
        else {
          notification('Something went wrong. Redirecting to view all tutorials');
          setTimeout(() => {
            navigate(COURSES_URL)
          }, 2500);
        }
  
      }).catch(e =>{
        setIsLoading(false);
        notification('Cannot get data from server');
      });
    }
    else navigate(COURSES_URL);
  },[queryParams]);

  return (
  <Main>
    <Container 
      maxWidth={'100%'}
      sx={{
        backgroundColor: theme.palette.alternate.main,
        paddingTop: 13,
        width: '100%',
      }}
    >
      <Box>
        <Typography
          variant={'h4'}
          gutterBottom
          align={'center'}
          sx={{ fontWeight: 700 }}
        >
            Time to practice and learn
        </Typography>
        <Typography
          display={'flex'}
          justifyContent={'center'}
          alignItems={'center'}
          variant={'h6'}
          component={'p'}
          color={'text.secondary'}
          align={'center'}
          maxWidth={"50%"}
          marginX={'auto'}
        >
            This page contains all well-hand-picked tutorials.
            </Typography>
        <Typography display={'flex'}
          justifyContent={'center'}
          alignItems={'center'}
          variant={'h6'}
          component={'p'}
          color={'text.secondary'}
          align={'center'}
          maxWidth={"50%"}
          marginX={'auto'}>
        We will keep updating the list.
        </Typography> 
      </Box>
    </Container>

    <Box
      component={'svg'}
      preserveAspectRatio="none"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 1920 100.1"
      sx={{
        marginBottom: -1,
        width: 1,
        marginTop: -4,
      }}
    >
      <path fill={theme.palette.background.paper}
        d="M0,0c0,0,934.4,93.4,1920,0v100.1H0L0,0z"/>
    </Box>

    <Container 
      paddingY={{xs: -2,sm:-10, md:-11}}
      // marginBottom={-4}
      display={'flex'}
      justifyContent={'center'}
      alignItems={'center'}
    >
      <Box width={'80%'} 
      maxWidth={'1000px'}>
        <SearchBar/>  
      </Box>

    </Container>
    <Container 
      display={'flex'}
      justifyContent={'center'}
      alignItems={'center'}
      paddingY={{ xs: 2, sm: 4, md: 4 }}
      maxWidth={'1500px'}
      marginX={'auto'}
    >
      <Box 
      width={'80%'} 
      maxWidth={'1000px'}
      >
        <Typography
        variant={'h6'}
        component={'p'}
        fontWeight={600}
        > <span sx={{}}>{stringToPascalCase(topic)} </span> Tutorials:
        </Typography>
        <Typography>
          Related topics: 
        </Typography>
      </Box>

    </Container>

    
    {isLoading && 
      <Container 
      marginTop={{xs: -2,sm:-10, md:-11}}
      marginBottom={-4}
      display={'flex'}
      justifyContent={'center'}
      alignItems={'center'}
       >
        <CircularProgress/>
      </Container>
    }

    <Container
      paddingTop={{ sm: 2, md: 4 }}

    >
      <CourseCard courses={courseRelated} authenticated={user.email !== undefined }/>
    </Container>
    
  </Main>
  )
};

export default CategoriesView;